import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { url, setHeaders } from "./api";
import {toast} from "react-toastify"
const initialState = {
  list: [],
  status: null,
  deletedStatus:null,
};
export const usersFetch = createAsyncThunk("users/usersFetch", async () => {
  try {
    
    const response = await axios.get(`${url}/users/users`, setHeaders());
    return response.data;
  } catch (error) {
    console.log(error);
  }
});
export const usersDelete=createAsyncThunk("users/usersDelete",async(id)=>{
  try{
    console.log(id);
      const response=await axios.delete(`${url}/users/users/${id}`,setHeaders())
      return response.data
  }
  catch(error){
    toast.error("error occured",{
      position:"top-right"
    })
  }

})
const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: {
    [usersFetch.pending]: (state, action) => {
      state.status = "pending";
    },
    [usersFetch.fulfilled]: (state, action) => {
      state.list = action.payload;
      state.status = "success";
    },
    [usersFetch.rejected]: (state, action) => {
      state.status = "rejected";
    },
    [usersDelete.pending]: (state, action) => {
      state.status = "pending";
    },
    [usersDelete.fulfilled]: (state, action) => {
      const updatedusers = state.list.filter((user) =>
        user._id !== action.payload._id
      );
      state.list = updatedusers;
      console.log(updatedusers)
      state.status = "success";
      toast.error("user Deleted",{
      position:"top-right"
    })
    },
    [usersDelete.rejected]: (state, action) => {
      state.status = "rejected";
    },
  }
});
export default usersSlice.reducer;
